export {default} from './TeamSettingDetailModel';
export {TeamSettingsDetailModelType} from './TeamSettingDetailModel';



// WEBPACK FOOTER //
// ./src/models/TeamSettingDetailModel/index.ts